export enum LinkType {
  external = "external",
  internal = "internal",
}

export enum AdType {
  sportsClub = "sportsClub",
}
